(() => {
  const root = window.Shopify?.routes?.root || '/';
  const toast = document.querySelector('.toast');
  let toastTimer;
  function notify(message, cartLink = false) {
    if (!toast) return;
    toast.replaceChildren(document.createTextNode(message));
    if (cartLink) { const a = document.createElement('a'); a.href = `${root}cart`; a.textContent = 'View cart'; toast.append(a); }
    toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 7000);
  }
  const menuButton = document.querySelector('.mobile-menu-button');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.getElementById('main-navigation')?.classList.toggle('is-open', open);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); });
    if (menuButton?.getAttribute('aria-expanded') === 'true') { menuButton.click(); menuButton.focus(); }
  });
  const carouselDisposers = new Map();
  function initCarousels(scope = document) {
    scope.querySelectorAll('[data-carousel]').forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-slide]')];
      const tabs = [...carousel.querySelectorAll('[data-slide-to]')];
      const pauseButton = carousel.querySelector('[data-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 719px)');
      let current = 0, timer, paused = false;
      const show = index => { current = index; slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index)); tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index))); };
      const stop = () => clearInterval(timer);
      const start = () => { stop(); const ms = Number(carousel.dataset.interval); if (ms > 0 && slides.length > 1 && !paused && !reduced.matches && !mobile.matches && !document.hidden) timer = setInterval(() => show((current + 1) % slides.length), ms); };
      tabs.forEach((tab, index) => tab.addEventListener('click', () => { show(index); start(); }));
      pauseButton?.addEventListener('click', () => { paused = !paused; pauseButton.textContent = paused ? '▶' : 'Ⅱ'; pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); start(); });
      carousel.addEventListener('mouseenter', stop); carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop); carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', start); mobile.addEventListener('change', start); reduced.addEventListener('change', start);
      carouselDisposers.set(carousel, () => { stop(); document.removeEventListener('visibilitychange', start); mobile.removeEventListener('change', start); reduced.removeEventListener('change', start); });
      start();
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', event => initCarousels(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-carousel]').forEach(el => { carouselDisposers.get(el)?.(); carouselDisposers.delete(el); }); });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-add-to-cart]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending) return;
    const button = event.submitter || form.querySelector('button[type=submit], button:not([type])');
    const buyNow = Boolean(button?.hasAttribute('data-buy-now'));
    const submitButtons = [...form.querySelectorAll('button[type=submit]')];
    submitButtons.forEach(el => { el.disabled = true; });
    const error = form.querySelector('.form-error');
    if (error) error.hidden = true;
    form.dataset.pending = 'true';
    const label = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      added = true;
      if (buyNow) { window.location.assign(`${root}checkout`); return; }
      if (!document.getElementById('cart-drawer')) notify('Added to your cart.', true);
      // A failed count refresh must never turn a successful add into a retry prompt.
      try { const cartResponse = await fetch(`${root}cart.js`); if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count ? `(${cart.item_count})` : ''; }); } } catch { /* The cart link remains usable. */ }
    } catch (failure) {
      const message = failure instanceof TypeError ? 'Could not confirm the cart update. Check your cart before trying again.' : failure.message;
      if (error) { error.textContent = message; error.hidden = false; }
      notify(message, failure instanceof TypeError);
    } finally {
      delete form.dataset.pending;
      submitButtons.forEach(el => { el.disabled = Boolean(form.closest('[data-product-detail]')?.querySelector('[data-variant-stock]')?.classList.contains('sold-out')); });
      if (button) { const soldOut = form.closest('[data-product-detail]')?.querySelector('[data-variant-stock]')?.classList.contains('sold-out'); button.disabled = Boolean(soldOut); button.textContent = soldOut ? 'Sold out' : (label || 'Add to cart'); }
      if (added && !buyNow) document.dispatchEvent(new CustomEvent('tcg:cart-added'));
    }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const detail = select.closest('[data-product-detail]');
    const variants = JSON.parse(detail.querySelector('[data-variants]').textContent);
    const variant = variants.find(v => String(v.id) === select.value);
    if (!variant) return;
    const price = detail.querySelector('[data-variant-price]');
    price.replaceChildren(document.createTextNode(variant.price));
    if (variant.compare) { const s = document.createElement('s'); s.textContent = variant.compare; price.append(s); }
    const stock = detail.querySelector('[data-variant-stock]'); stock.textContent = variant.available ? 'In stock' : 'Out of stock'; stock.classList.toggle('sold-out', !variant.available);
    const button = detail.querySelector('[data-product-submit]'); button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Sold out';
    const quantity = detail.querySelector('[name=quantity]'); quantity.min = variant.min; quantity.step = variant.step; quantity.value = variant.min; if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
    if (!detail.closest('dialog')) { const current = new URL(location.href); current.searchParams.set('variant', variant.id); history.replaceState({}, '', current); }
    const media = variant.mediaId && detail.querySelector(`[id$="Media-${variant.mediaId}"]`); if (media && !media.hasAttribute('data-gallery-slide')) media.parentNode.prepend(media);
  });
  const dialog = document.getElementById('quick-shop');
  let quickShopController;
  dialog?.querySelector('.dialog-close')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('close', () => quickShopController?.abort());
  dialog?.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-quick-shop]');
    if (!trigger || !dialog) return;
    quickShopController?.abort(); quickShopController = new AbortController();
    const content = dialog.querySelector('.quick-shop-content'); content.textContent = 'Loading product…'; dialog.showModal();
    try {
      const response = await fetch(trigger.dataset.quickShop, { signal: quickShopController.signal });
      if (!response.ok) throw new Error('Unable to load product');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = html.querySelector('[data-product-detail]');
      if (!product) throw new Error('Product unavailable');
      // Scope IDs to avoid duplicates when opened from another product page.
      const ids = new Map(); product.querySelectorAll('[id]').forEach(el => { const previous = el.id; el.id = `Quick-${previous}`; ids.set(previous, el.id); });
      product.querySelectorAll('[for]').forEach(el => { if (ids.has(el.htmlFor)) el.htmlFor = ids.get(el.htmlFor); });
      content.replaceChildren(product);
    } catch (error) { if (error.name === 'AbortError') return; content.replaceChildren(document.createTextNode('Open the product page to see its details. ')); const link = document.createElement('a'); link.href = trigger.dataset.quickShop; link.textContent = 'View product'; content.append(link); }
  });
})();
